import { chakra, HTMLChakraProps } from '@chakra-ui/react';
import { FC, useMemo } from 'react';
import ReactMarkdown from 'react-markdown';

import { convertTimestampsToLocalizedTime } from '@/utils/timestampToLocalizedTime';

const ChakraMarkdown = chakra(ReactMarkdown, {
  baseStyle: {
    fontFamily: 'body',
    p: {
      whiteSpace: 'pre-wrap',
      my: '1rem',
      ':first-of-type': {
        mt: 0,
      },
      ':last-of-type': {
        mb: 0,
      },
    },
    img: {
      display: 'inline-block',
    },
    'h1, h2, h3, h4, h5, h6': {
      my: '2.5rem',
      fontFamily: 'heading',
    },
    h1: {
      fontSize: '3rem',
      lineHeight: '3.75rem',
    },
    h2: {
      fontSize: '2.25rem',
      lineHeight: '3rem',
    },
    h3: {
      fontSize: '2rem',
      lineHeight: '2.5rem',
    },
    h4: {
      fontSize: '1.75rem',
      lineHeight: '2.25rem',
    },
    a: {
      fontFamily: 'heading',
      color: 'blue.500',
      ':hover': {
        fontFamily: 'underline',
      },
      ':visited': {
        color: 'blue.500',
      },
    },
    blockquote: {
      p: {
        quotes: "'“' '”' '‘' '’'",
        '::before': {
          content: 'open-quote',
        },
        '::after': {
          content: 'close-quote',
        },
      },
    },
    'ul, ol': {
      pl: '1.25rem',
      mx: 0,
      my: '1.25rem',
      p: {
        m: 0,
      },
    },
    ul: {
      listStyle: 'disc',
    },
  },
});

type IGeneralMarkdown = ReactMarkdown.ReactMarkdownProps & HTMLChakraProps<'div'>;

export const GeneralMarkdown: FC<IGeneralMarkdown> = ({ source, ...props }) => {
  // we are modifing source since we are using some custom markdown syntax for some elements (timestamps, ...)
  const modifiedSource = useMemo(() => convertTimestampsToLocalizedTime(source), [source]);

  return <ChakraMarkdown source={modifiedSource} escapeHtml={false} {...props} />;
};
